import { useState, useCallback } from 'react';
import { toast } from './use-toast';

/**
 * useContactForm
 * Encapsulates contact form state and submit handler.
 */
export function useContactForm() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });

  const updateField = useCallback((field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  }, []);

  const reset = useCallback(() => {
    setForm({ name: '', email: '', subject: '', message: '' });
  }, []);

  const submit = useCallback((e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!form.name || !form.email) {
      toast({ title: 'Missing information', description: 'Please provide your name and email.' });
      return false;
    }
    toast({ title: 'Message received', description: `Thank you, ${form.name}. We\u2019ll be in touch shortly.` });
    reset();
    return true;
  }, [form, reset]);

  return { form, updateField, submit, reset };
}
